module.exports = __webpack_public_path__ + "img/28.1ae2fe25.jpg";